import React from 'react';
import ps from '../../../images/banner/ps5.webp'
import { motion } from "framer-motion";

const Banner = ({openModal}) => {
    return (
        <div className='banner'>
            <motion.div
                initial={{ opacity: 0, y: 200 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
                className="p-6 bg-blue-500 text-white rounded-lg shadow-lg">
                <div className="container">
                    <div className='banner-content'>
                        <div className='banner-img'>
                            <h1 className='banner-heading-top'>
                                Дешево <br/> спробувати!
                            </h1>
                            <img src={ps} alt=""/>
                        </div>

                        <div className="banner-row">
                            <h1 className='banner-heading-btm'>
                                Дешево спробувати!
                            </h1>
                            <h2 className='banner-heading-2'>Усього <span style={{color: 'red'}}>від <span
                                className='numbers'>190</span></span> гривень на день. </h2>
                            <p className='banner-desc'>Власна консоль ще ніколи не була такою доступною.</p>
                            <div style={{width: '100%', textAlign: 'center'}}>
                                <button className='red-btn banner-btn' onClick={openModal}>Спробувати</button>
                            </div>

                        </div>
                    </div>

                </div>
            </motion.div>
        </div>
    );
};

export default Banner;